<template>
  <div class="main">
    <div class="back" @click="backBtn">
      <i></i>
      <span>返回</span>
    </div>
    <div class="content">
      <ul>
        <li @click="toContentUrl(2)">
          <div>
            <img src="@/assets/student/chapter.png" alt="" />
            <p>医学题库</p>
            <p class="text">海量题库，自由练习</p>
          </div>
        </li>
        <li  @click="toContentUrl(3)">
          <div>
            <img src="@/assets/student/model_exam.png" alt="" />
            <p>模拟考场</p>
            <p class="text">模拟真实考试 提高实战经验</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["cutcoms"],
  methods: {
    // 返回
    backBtn() {
      this.$destroy();
      this.cutcoms(0);
    },
    // 跳转对应内容
    toContentUrl(type){
       this.cutcoms(type)
    }
  },
};
</script>

<style lang="scss" scoped>
.main {
  min-height: 780px;
  padding: 24px;
  .content {
    width: 100%;
    height: 74vh;
    display: flex;
    justify-content: center;
    align-items: center;
    > ul {
      display: flex;
      > li {
        width: 275px;
        height: 358px;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        //   .text {
        //     background: #f8f8f8;
        //     border-radius: 10px;
        //     letter-spacing: 2px;
        //     padding: 20px;
        //   }
        > div {
          > p {
            &:nth-child(2) {
              font-size: 18px;
              margin-top: 24px;
            }
            &:nth-child(3) {
              background: #f8f8f8;
              border-radius: 10px;
              letter-spacing: 2px;
              padding: 20px;
              margin-top: 40px;
            }
          }
        }
        &:nth-child(1) {
          margin-right: 110px;
          > div > img {
            width: 160px;
            height: 160px;
            box-shadow: -5px 0 5px rgba(0, 0, 0, 0.2),
              5px 0 5px rgba(0, 0, 0, 0.2), 0 5px 5px rgba(0, 0, 0, 0.2),
              0 -5px 5px rgba(0, 0, 0, 0.2);
          }
        }
        &:hover {
          border: 1px dashed #808a87;
        }
      }
    }
  }
}
// 返回按键css
.back {
  border-bottom: 1px solid #f8f8f8;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  height: 44px;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
</style>